import { useState, useMemo } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import styles from '../_shared/CrudPage.module.css'

import indice from './00-indice.md?raw'
import elaboradora from './01-elaboradora.md?raw'
import cliente from './02-cliente.md?raw'
import executora from './03-executora.md?raw'
import laboratorio from './04-laboratorio.md?raw'
import rtMecanico from './05-rt-mecanico.md?raw'
import rtQai from './06-rt-qai.md?raw'
import adminTenant from './07-admin-tenant.md?raw'
import onboarding from './08-onboarding.md?raw'
import pmocOperacao from './09-pmoc-operacao.md?raw'

interface Capitulo {
  id: string
  titulo: string
  emoji: string
  conteudo: string
}

const CAPITULOS: Capitulo[] = [
  { id: 'pmoc-operacao', titulo: 'PMOC e operação', emoji: 'PMOC', conteudo: pmocOperacao },
  { id: 'indice', titulo: 'Índice', emoji: '📚', conteudo: indice },
  { id: 'onboarding', titulo: 'Onboarding rápido', emoji: '🚀', conteudo: onboarding },
  { id: 'admin-tenant', titulo: 'Administrador', emoji: '⚙️', conteudo: adminTenant },
  { id: 'elaboradora', titulo: 'Elaboradora', emoji: '🏛️', conteudo: elaboradora },
  { id: 'cliente', titulo: 'Cliente (Contratante)', emoji: '🏢', conteudo: cliente },
  { id: 'executora', titulo: 'Executora', emoji: '🔧', conteudo: executora },
  { id: 'laboratorio', titulo: 'Laboratório', emoji: '🧪', conteudo: laboratorio },
  { id: 'rt-mecanico', titulo: 'RT Mecânico', emoji: '👷', conteudo: rtMecanico },
  { id: 'rt-qai', titulo: 'RT QAI', emoji: '🔬', conteudo: rtQai },
]

export default function ManualPage() {
  const [ativo, setAtivo] = useState<string>('indice')

  const capituloAtivo = useMemo(
    () => CAPITULOS.find((c) => c.id === ativo) ?? CAPITULOS[0],
    [ativo],
  )

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <h1 className={styles.title}>Manual de uso</h1>
          <p className={styles.subtitle}>
            Documentação por perfil — clique no capítulo na lateral.
          </p>
        </div>
      </header>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '240px 1fr',
          gap: '1.5rem',
          alignItems: 'flex-start',
        }}
      >
        <nav
          aria-label="Capítulos do manual"
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--border)',
            borderRadius: 8,
            padding: '0.75rem',
            position: 'sticky',
            top: '1rem',
          }}
        >
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
            }}
          >
            {CAPITULOS.map((c) => (
              <li key={c.id}>
                <button
                  type="button"
                  onClick={() => setAtivo(c.id)}
                  data-testid={`manual-link-${c.id}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    width: '100%',
                    padding: '0.5rem 0.75rem',
                    border: 'none',
                    borderRadius: 6,
                    background: ativo === c.id ? 'var(--primary, #1565C0)' : 'transparent',
                    color: ativo === c.id ? '#fff' : 'inherit',
                    cursor: 'pointer',
                    textAlign: 'left',
                    fontSize: 14,
                    fontWeight: ativo === c.id ? 600 : 400,
                  }}
                >
                  <span aria-hidden="true">{c.emoji}</span>
                  <span>{c.titulo}</span>
                </button>
              </li>
            ))}
          </ul>
        </nav>

        <article
          className="manual-conteudo"
          data-testid="manual-conteudo"
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--border)',
            borderRadius: 8,
            padding: '1.5rem 2rem',
            maxWidth: 920,
            lineHeight: 1.6,
          }}
        >
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{capituloAtivo.conteudo}</ReactMarkdown>
        </article>
      </div>
    </div>
  )
}
